import React from 'react';
import _ from '../../../utils/lodash';
import TreatmentInstanceList from '../TreatmentInstanceList/TreatmentInstanceList';
import TreatmentFilterBox from '../../../containers/DailyPlanning/TreatmentFilterBox/TreatmentFilterBoxContainer';

class TreatmentPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { scrollNumber: 167 };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScrollThrottled);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollThrottled);
  }
  getPanelStyle = () => ({ top: `${this.state.scrollNumber}px` });

  getScrollTop = () => (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

  handleScroll = () => {
    const scrollTops = this.getScrollTop();
    let nextScrollTopPosition;
    if (scrollTops <= 167) {
      nextScrollTopPosition = 167 - Math.abs(scrollTops);
    } else {
      nextScrollTopPosition = 0;
    }
    this.setState({ scrollNumber: nextScrollTopPosition });
  };

  handleScrollThrottled = _.throttle(this.handleScroll, 10, { trailing: true });

  render = () => (
    <section className="content-aside">
      <div className="side-holder" style={this.getPanelStyle()}>
        <TreatmentFilterBox />
        <TreatmentInstanceList {...this.props} />
      </div>
    </section>
  );
}

export default TreatmentPanel;
